import { AgGridModule } from 'ag-grid-angular';
import { NgrxFormsModule } from 'ngrx-forms';
import { MomentModule } from 'ngx-moment';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { CheckRequirementsComponent } from './check-requirements/check-requirements.component';
import { CompanyDataComponent } from './company-data/company-data.component';
import { CountryCardListComponent } from './country-card-list/country-card-list.component';
import { DatagridComponent } from './datagrid/datagrid.component';
import { DocumentFormComponent } from './document-form/document-form.component';
import { ExpandablePanelComponent } from './expandable-panel/expandable-panel.component';
import { ExpirationDateCellComponent } from './expiration-date/expiration-date-cell.component';
import { ExpirationDateComponent } from './expiration-date/expiration-date.component';
import { FileReaderComponent } from './file-reader/file-reader.component';
import { LicenseComponent } from './license/license.component';
import { MaterialModule } from './material/material.module';
import { NgrxFormsMaterialModule } from './ngrx-forms-material/ngrx-forms-material.module';
import { TextFilterPipe } from './text-filter.pipe';
import { UsersComponent } from './users/users.component';

@NgModule({
  declarations: [
    TextFilterPipe,
    FileReaderComponent,
    ExpandablePanelComponent,
    CompanyDataComponent,
    DocumentFormComponent,
    LicenseComponent,
    DatagridComponent,
    CheckRequirementsComponent,
    ExpirationDateComponent,
    ExpirationDateCellComponent,
    CountryCardListComponent,
    AutocompleteComponent,
    UsersComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgrxFormsModule,
    MaterialModule,
    NgrxFormsMaterialModule,
    MomentModule,
    TranslateModule,
    RouterModule,
    AgGridModule.withComponents([ExpirationDateCellComponent]),
  ],
  providers: [],
  exports: [
    NgrxFormsModule,
    ReactiveFormsModule,
    FormsModule,
    TextFilterPipe,
    MomentModule,
    TranslateModule,
    FileReaderComponent,
    ExpandablePanelComponent,
    NgrxFormsMaterialModule,
    MaterialModule,
    CompanyDataComponent,
    DocumentFormComponent,
    LicenseComponent,
    DatagridComponent,
    CheckRequirementsComponent,
    ExpirationDateComponent,
    CountryCardListComponent,
    AutocompleteComponent,
    UsersComponent,
  ],
})
export class SharedModule {}
